import React from 'react'

const ReturnPolicy = () => {
  return (
    <div className="flex justify-center bg-gray-100 py-8 px-4 font-['Poppins']">
    <div className="w-full max-w-4xl">
      <h1 className="text-center text-xl font-medium text-[#53686A] mb-6">Refund Policy</h1>
      
      <div className="bg-white p-6 md:p-8 border-black border-[1px]">
        <div className="mb-6">
          <p className="text-sm md:text-base text-gray-800 leading-relaxed">
            At Hellocer, we understand the importance of providing transparent policies to our valued customers. As part of 
            our commitment to ensuring a positive experience for both employers and job seekers, we have developed the 
            following refund policy regarding our job posting services.
          </p>
        </div>

        <div className="mb-6">
          <h2 className="font-medium text-sm md:text-base mb-2">1. Refund Eligibility: <span className="font-normal">Refunds are only applicable in specific circumstances outlined below:</span></h2>
          <div className="ml-4 md:ml-6 space-y-3">
            <div>
              <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                <span className="mr-1">1.1</span> In event of accidental duplicate charges for the same job posting, users are eligible for a full refund of 
                the duplicate transaction.
              </p>
            </div>
            <div>
              <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                <span className="mr-1">1.2</span> If technical issues on our platform result in unwanted charges in job postings, user request for a refund 
                for the affected transaction.
              </p>
            </div>
            <div>
              <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                <span className="mr-1">1.3</span> If a job posted is been removed by Hellocer due to violation of our terms of service user may be eligible 
                for a refund at our judgement about violating our rules.
              </p>
            </div>
          </div>
        </div>

        <div className="mb-6">
          <h2 className="font-medium text-sm md:text-base mb-2">2. Refund Procedure: <span className="font-normal">To request for a refund, users must contact our customer support team within 24 hours of of the transaction date. Refund request should include following information:</span></h2>
          <div className="ml-4 md:ml-6 space-y-3">
            <div>
              <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                <span className="mr-1">2.1</span> Username and contact details.
              </p>
            </div>
            <div>
              <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                <span className="mr-1">2.2</span> Transaction ID or reference number.
              </p>
            </div>
            <div>
              <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                <span className="mr-1">2.3</span> Reason for refund request
              </p>
            </div>
            <div>
              <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                <span className="mr-1">2.4</span> Any supporting documentation or evidence, such as screenshots or email correspondence
              </p>
            </div>
          </div>
        </div>

        <div className="mb-6">
          <h2 className="font-medium text-sm md:text-base mb-2">3. Refund Processing: <span className="font-normal">Once a refund request is received and validated by our customer support team, refunds will be processed within24 hours. The refund amount will be credited back to the original payment method used for the transaction.</span></h2>
        </div>

        <div className="mb-6">
          <h2 className="font-medium text-sm md:text-base mb-2">4. Non-Refundable Items: <span className="font-normal">Please note that certain items are non-refundable, which includes:</span></h2>
          <div className="ml-4 md:ml-6 space-y-3">
            <div>
              <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                <span className="mr-1">4.1</span> Featured job postings or premium upgrades
              </p>
            </div>
            <div>
              <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                <span className="mr-1">4.2</span> Subscription fees for recurring services
              </p>
            </div>
            <div>
              <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                <span className="mr-1">4.3</span> Job Postings that have already received significant exposure or engagement
              </p>
            </div>
          </div>
        </div>

        <div className="mb-6">
          <h2 className="font-medium text-sm md:text-base mb-2">5. Dispute Resolution: <span className="font-normal">In the event of a dispute regarding a refund request, Hellocer reserves the right to investigate the matter further and make a final determination based on our refund policy and terms of service.</span></h2>
        </div>

        <div className="mb-6">
          <h2 className="font-medium text-sm md:text-base mb-2">6. Changes to Refund Policy: <span className="font-normal">Hellocer reserves the right to modify or update this refund policy at any time without prior notice. Users are encouraged to review the refund policy periodically for changes or updates.</span></h2>
        </div>

        <div className="mb-6">
          <p className="text-sm md:text-base text-gray-800 leading-relaxed">
            By utilizing the services of Hellocer, users agree to abide by the terms outlined in this refund policy. We strive to provide exceptional customer service and address any concerns or issues promptly and fairly.
          </p>
        </div>

        <div className="mb-4">
          <p className="text-sm md:text-base text-gray-800 leading-relaxed">
            If you have any questions or require assistance regarding our refund policy, please don't hesitate to contact our customer support team.
          </p>
        </div>

        <div>
          <p className="text-sm md:text-base text-gray-800 leading-relaxed">
            Thank you for choosing Hellocer for your recruitment needs.
          </p>
        </div>
      </div>
    </div>
  </div>
  )
}

export default ReturnPolicy